import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainWrapper: {
        display: "flex",
        flexDirection: "column",
        textAlign: "left",
        marginTop: 64,
        fontFamily: "Open Sans",
        backgroundColor: theme.palette.backgrounds.main,
        minHeight: "calc(100vh - 64px)",
    },
    mainTitle: {
        fontSize: "24px",
        fontWeight: 400,
        color: theme.palette.text.primary,
        marginBottom: 30,
        padding: "30px 22px 0px 22px",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0px 22px",
        marginTop: theme.spacing(4),
    },
    reportSelectWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    reportSelectLabel: {
        fontSize: 12,
        fontWeight: 700,
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
        marginBottom: 6,
    },
    reportSelect: {
        minWidth: 237,
        backgroundColor: theme.palette.primary.main,
        "& fieldset": {
            borderColor: theme.palette.border.select,
        },
        "& .MuiSelect-select": {
            fontSize: 14,
            fontWeight: 400,
            color: theme.palette.primary.darker,
            fontFamily: "Open Sans",
            padding: "9px 12px",
        },
    },
    headerSide: {
        display: "flex",
        gap: 16,
    },
    headerActionWrapper: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        cursor: "pointer",
    },
    headerFilterButton: {
        "& button": {
            backgroundColor: theme.palette.primary.dark,
            border: "1px solid transparent !important",
            color: `${theme.palette.primary.main} !important`,
        },
        "& button:hover": {
            backgroundColor: theme.palette.primary.dark,
            border: "1px solid transparent !important",
            color: `${theme.palette.primary.main} !important`,
        },
        "& button.Mui-selected": {
            backgroundColor: theme.palette.info.main,
        },
        "& button.Mui-selected:hover": {
            backgroundColor: theme.palette.info.main,
        },
    },
    datePickersWrapper: {
        display: "flex",
        flexDirection: "column",
    },
    headerActions: {
        display: "flex",
        gap: 16,
        color: theme.palette.info.main,
        fontFamily: "Open Sans",
        fontWeight: 700,
        fontSize: 12,
        textDecorationLine: "underline",
        textTransform: "uppercase",
    },
    dateRange: {
        minWidth: 237,
    },
}));
